import { useEffect, useRef } from "react";
import { txt } from "@/lib/format";
import { CATEGORY_ICONS } from "@/lib/icons";

export const CategoryNav = ({ s, lang, t, categories, active, onSelect }) => {
  const scroller = useRef(null);
  useEffect(() => {
    const c = scroller.current;
    const el = c?.querySelector(`[data-cat="${active}"]`);
    if (!el) return;
    const cr = c.getBoundingClientRect();
    const er = el.getBoundingClientRect();
    if (er.left < cr.left + 16 || er.right > cr.right - 16) {
      c.scrollBy({ left: er.left + er.width / 2 - (cr.left + cr.width / 2), behavior: "smooth" });
    }
  }, [active, lang]);

  const pill = s.nav.style === "pill";
  return (
    <nav aria-label={t("pub.categories")} data-testid="category-nav" className="border-b backdrop-blur-xl" style={{ background: "color-mix(in srgb, var(--wt-bg) 90%, transparent)", borderColor: "color-mix(in srgb, var(--wt-text) 8%, transparent)" }}>
      <div ref={scroller} className={`no-scrollbar mx-auto flex max-w-6xl overflow-x-auto px-4 sm:px-6 ${pill ? "gap-2 py-3" : "gap-5 pt-2"}`}>
        {categories.map((c) => {
          const on = c.id === active;
          const Icon = s.nav.show_icons ? CATEGORY_ICONS[c.icon] : null;
          const base = "flex min-h-[40px] shrink-0 items-center gap-2 whitespace-nowrap text-sm font-semibold transition-[background-color,color,border-color] duration-200";
          const cls = pill
            ? `${base} rounded-full px-4 ${on ? "text-white shadow-lg" : "text-[var(--wt-muted)] hover:text-[var(--wt-text)]"}`
            : `${base} border-b-2 pb-2 ${on ? "border-[var(--wt-primary)] text-[var(--wt-text)]" : "border-transparent text-[var(--wt-muted)] hover:text-[var(--wt-text)]"}`;
          const style = pill ? { background: on ? "var(--wt-primary)" : "color-mix(in srgb, var(--wt-text) 7%, transparent)" } : undefined;
          return (
            <button key={c.id} type="button" data-cat={c.id} data-testid={`category-tab-${c.id}`} aria-current={on ? "true" : undefined} onClick={() => onSelect(c.id)} className={cls} style={style}>
              {Icon && <Icon className="h-4 w-4" />}
              <span>{txt(c, "name", lang)}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
